import * as React from "react";
import { getRecents } from "./recents";
import type { SelectOption } from "./types";

interface UseSelectRecentsOptions {
  enableRecents: boolean;
  recentKey?: string;
  options: SelectOption[];
  effectiveSearch: string;
  recentsNonce: number;
}

/**
 * Hook to compute and manage recent options for select components
 */
export function useSelectRecents({
  enableRecents,
  recentKey,
  options,
  effectiveSearch,
  recentsNonce,
}: UseSelectRecentsOptions): SelectOption[] {
  return React.useMemo(() => {
    if (!(enableRecents && recentKey)) return [];
    const recents = getRecents(recentKey);
    const mapped = recents
      .map((r) => ({ value: r.id, label: r.label }))
      .filter((r) => !options.some((o) => o.value === r.value));
    const merged = [...mapped, ...options.filter((o) => recents.some((r) => r.id === o.value))];
    const search = (effectiveSearch || "").toLowerCase();
    return search ? merged.filter((o) => o.label.toLowerCase().includes(search)) : merged;
  }, [enableRecents, recentKey, options, effectiveSearch, recentsNonce]);
}
